import React, { useEffect, useRef, useState } from "react";
import { BiSolidBadgeCheck } from "react-icons/bi";
import { FaFilter, FaPlus, FaEye, FaTrash, FaEdit } from "react-icons/fa";
import AddLeadModal from "../components/Modals/LeadModal";
import ShowLeadModal from "../components/Modals/ShowLeadModal";
import FollowupModal from "../components/Modals/FollowupModal";
import { BsThreeDotsVertical } from "react-icons/bs";
import { RiChatFollowUpFill } from "react-icons/ri";
import { MdCallMissedOutgoing } from "react-icons/md";
import AppPagination from "../components/AppPagination";
import StaffModal from "../components/Modals/StaffModal";
import AppModal from "../components/Modals/AppModal";
import DeleteModal from "../components/Modals/DeleteModal";

const Staff = ({ staff }) => {
  const [showFilter, setShowFilter] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showStaffModal, setShowStaffModal] = useState(false);

  const [editData, setEditData] = useState(null);
  const menuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDelete = () => {
    console.log(deleteId);

    setShowDeleteModal(false);
  };

  const confirmDelete = () => {
    console.log("Delete ID:", deleteId);

    setShowDeleteModal(false);
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [deleteId, setDeleteId] = useState(null);

  const toggleFilter = () => {
    setShowFilter((prev) => !prev);
  };

  const [loading, setLoading] = useState(true);
  const [showFollowup, setShowFollowup] = useState(false);
  const [showMissedModal, setShowMissedModal] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  const staffData = [
    {
      id: 1,
      name: "Amit Sharma",
      email: "amit@gmail.com",
      mobile: "9876543210",
      role: "Admin",
      department: "Management",
      joining_date: "2026-05-10",
      salary: "50000",
      status: "Active",
      address: "Jaipur Rajasthan",
      image: "https://i.pravatar.cc/150?img=1",
    },

    {
      id: 2,
      name: "Rahul Verma",
      email: "rahul@gmail.com",
      mobile: "9123456780",
      role: "Developer",
      department: "IT",
      joining_date: "2026-05-08",
      salary: "40000",
      status: "Active",
      address: "Delhi",
      image: "https://i.pravatar.cc/150?img=2",
    },

    {
      id: 3,
      name: "Sonia Mehta",
      email: "sonia@gmail.com",
      mobile: "9988776655",
      role: "Designer",
      department: "UI/UX",
      joining_date: "2026-05-01",
      salary: "35000",
      status: "Inactive",
      address: "Mumbai",
      image: "https://i.pravatar.cc/150?img=3",
    },

    {
      id: 4,
      name: "Vikas Yadav",
      email: "vikas@gmail.com",
      mobile: "9000011111",
      role: "Manager",
      department: "Sales",
      joining_date: "2026-04-20",
      salary: "60000",
      status: "Active",
      address: "Indore",
      image: "https://i.pravatar.cc/150?img=4",
    },
  ];

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = staffData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(staffData.length / itemsPerPage);

  const changePage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [show, setShow] = useState(false);
  const [showView, setShowView] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);

  return (
    <div className="lead-page">
      <div className="lead-header ">
        <div className="d-flex align-items-center">
          <h2 className="mb-1">Staff</h2>
        </div>

        <div className="ms-auto d-flex flex-row"></div>
        <button
          className="btn btn-primary"
          onClick={() => {
            setEditData(null);
            setShowStaffModal(true);
          }}
        >
          <FaPlus className="me-1" />
          Add Staff
        </button>
      </div>

      <div className="card mb-4 card-light">
        <div className="card-header justify-content-between align-items-center">
          <h5 className="card-title">All Staff</h5>
          <div className="d-flex flex-row gap-2 justify-content-between align-items-center">
            {showFilter && (
              <div className="card filter-grid">
                <input
                  className="w-100 form-control"
                  type="text"
                  placeholder="Search By Name"
                />
              </div>
            )}
            <button className="btn btn-dark" onClick={toggleFilter}>
              <FaFilter className="me-1" />
              Filter
            </button>

            <div className="position-relative" ref={menuRef}>
              {showMenu && (
                <div className="custom-dropdown-menu shadow">
                  <button
                    className="dropdown-item-custom"
                    onClick={() => setShowFollowup(true)}
                  >
                    <RiChatFollowUpFill />
                    Add Lead Followup
                  </button>

                  <button
                    className="dropdown-item-custom"
                    onClick={() => setShowMissedModal(true)}
                  >
                    <MdCallMissedOutgoing />
                    Lead Missed Followup
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="table-outer border">
            <div className="table-responsive">
              <table className="table m-0 align-middle">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Role</th>
                    <th>Status</th>
                    <th>Joining Date</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        Loading...
                      </td>
                    </tr>
                  ) : currentItems.length > 0 ? (
                    currentItems.map((staff) => (
                      <tr key={staff.id}>
                        <td>{staff.id}</td>

                        <td className="fw-semibold">
                          <div className="d-flex align-items-center gap-2">
                            <img
                              src={staff.image}
                              alt={staff.name}
                              width="40"
                              height="40"
                              className="rounded-circle object-fit-cover border"
                            />

                            <span className="fw-semibold">{staff.name}</span>
                          </div>
                        </td>

                        <td>{staff.email}</td>

                        <td>{staff.mobile}</td>

                        <td>
                          <span className="badge bg-info">{staff.role}</span>
                        </td>

                        <td>
                          <span
                            className={`badge ${
                              staff.status === "Active"
                                ? "bg-success"
                                : "bg-danger"
                            }`}
                          >
                            {staff.status}
                          </span>
                        </td>

                        <td>{staff.joining_date}</td>

                        <td>
                          <div className="d-flex gap-2">
                            {/* Edit */}
                            <button
                              className="btn btn-sm btn-info custum_edit text-white"
                              onClick={() => {
                                setEditData(staff);
                                setShowStaffModal(true);
                              }}
                            >
                              <FaEdit />
                            </button>

                            {/* Delete */}
                            <button
                              className="btn btn-sm btn-info custum_danger"
                              onClick={() => {
                                setDeleteId(staff.id);
                                setShowDeleteModal(true);
                              }}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {/* Pagination */}
          <div className="row mt-2 p-2">
            <div className="col-md-12">
              <AppPagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={staffData.length}
                itemsPerPage={itemsPerPage}
                onPageChange={changePage}
              />
            </div>
          </div>
        </div>
      </div>

      <StaffModal
        show={showStaffModal}
        setShow={setShowStaffModal}
        editData={editData}
      />

      <DeleteModal
        show={showDeleteModal}
        setShow={setShowDeleteModal}
        onConfirm={handleDelete}
        title="Delete Staff"
        message="Are you sure you want to delete this staff?"
      />
    </div>
  );
};

export default Staff;
